

import {
	ICompany,
	IUpdateCompanyData,
	IUpdateCompanyMfo,
	IUpdateCompanyUlName
} from "@/api/mainPage/company/interface";
import { PROFILE_MODULE_NAME } from "@/store/modules/profile";
import { Component, Mixins, Watch } from "vue-property-decorator";
import GlobalMixin from "@/mixins/global";
import { HEADER_MODULE_NAME } from "@/store/modules/header";
import { Getter, Mutation } from "vuex-class";
import { BindingOptions } from "vuex-class/lib/bindings";
import IbDropdownLang from "@/components/Dropdown/DropdownLang.vue";
import IBModal from "@/components/Modal/IBModal.vue";
import OperationDay from "@/components/OperationDay/OperationDay.vue";
import { $changeCustomerCompany, $getCustomerCompany } from "@/api/mainPage/company/company";
import { profileEntity } from "@/models/modules/profile/entity";
import profileMethods from "@/models/modules/profile";
import IBDropdownClose from "@/components/Dropdown/IBDropdownClose";
import IBModalStore from "@/components/Modal/IBModalStore";
import EventEmitter from "@/modules/Event/EventEmitter";
import { EventEmitterName } from "@/modules/Event/interface";
import { IProfileEntity } from "@/models/modules/profile/interface";
import IBDialogSms from "../IBDialog/IBDialogSms.vue";
import DigitalSignPasswordDialog from "@/feature/Auth/components/DigitalSignPasswordDialog.vue";
import ChangeCompany from "@/feature/Auth/mixins/ChangeCompany";
import HeaderProfileDropdown from "@/components/Header/HeaderProfileDropdown.vue";
import { Ref } from "vue";
import { RouteMeta } from "vue-router";

const HeaderStoreModuleConfig: BindingOptions = { namespace: HEADER_MODULE_NAME };
const CompanyModuleConfig: BindingOptions = { namespace: PROFILE_MODULE_NAME };

@Component({
	components: {
		HeaderProfileDropdown,
		OperationDay,
		IBModal,
		IbDropdownLang,
		IBDialogSms,
		DigitalSignPasswordDialog
	}
})
export default class Header extends Mixins(
	GlobalMixin,
	IBDropdownClose,
	IBModalStore,
	ChangeCompany
) {

	@Getter('profile', CompanyModuleConfig)
	readonly profile?: IProfileEntity

	@Getter("mainButtonVisibility", HeaderStoreModuleConfig)
	readonly mainButtonVisibility!: boolean;

	@Mutation("incrementMainButtonClickedKey", HeaderStoreModuleConfig)
	incrementMainButtonClickedKey() {}

	@Getter("company", CompanyModuleConfig)
	readonly company!: ICompany | null;

	isDropdown: boolean = false;

	right: any

	notificationCount: string = '0'

	constructor() {
		super();

		this.right = {
			icon: "plus"
		};
	}

	get flCrmId(): number | null {
		return this.company && this.company.flCrmId;
	}

	get chipsDropdown(): IUpdateCompanyUlName[] {
		return (this.company && this.company.employeeInfo) || [];
	}

	get inputText(): string | undefined {
		return profileEntity.profileData?.ulName;
	}

	get inputMfo(): string | undefined {
		return profileEntity.profileData?.mfoUl;
	}

	get routeMeta(): any {
		return this.$route?.meta || undefined
	}

	@Watch('$route')
	changeRouteParams() {
		this.$route.params.count = this.notificationCount
	}

	dropdownOpen(refs: Ref) {
		this.isDropdown = !this.isDropdown;

		if (this.isSm) {
			this.isDropdown = false;
			this.modalClick();
		}
	}

	dropdownChange({chip, item}) {
		if (this.profile?.ulCrmId === chip.ulCrmId) {
			$changeCustomerCompany(this.postProfile(chip.ulCrmId, item.mfoUl))
				.then(() => {
					EventEmitter.emit(EventEmitterName.COMPANY_CHANGE);

					this.updateProfile();
				});

			if (this.isSm) {
				this.modalClick();
			}
		} else {
			this.prepareNewCompany({
				...chip,
				branch: item,
				flCrmId: this.flCrmId
			});
		}
	}

	updateProfile() {
		$getCustomerCompany({ transliteration: "true" }).then((profile: IUpdateCompanyData) => {
			profileMethods.setProfile(this.getProfileDataForStore(profile));

			profileEntity.company = profile;
		})
	}

	modalClick() {
		this.isActiveModal = !this.isActiveModal;
	}

	postProfile(ulCrm: number, mfoUl: string) {
		return {
			ulCrmId: ulCrm,
			mfo: mfoUl
		};
	}

	getProfileDataForStore(profile: IUpdateCompanyData): IProfileEntity | undefined {
		const defaultProfile: IUpdateCompanyUlName | undefined = profile.employeeInfo.find(v => v.branches.find(i => i.isCurrent));

		if (!defaultProfile) return;

		const defaultBranch: IUpdateCompanyMfo | undefined = defaultProfile.branches.find(v => v.isCurrent);

		if (!defaultBranch) return;

		return {
			flCrmId: profile.flCrmId,
			ulCrmId: defaultProfile.ulCrmId,
			ulName: defaultProfile.ulName,
			role: defaultProfile.role,
			mfoUl: defaultBranch.mfoUl,
			nciId: defaultBranch.nciId,
			ulCity: defaultProfile.ulCity,
			ulAddress: defaultProfile.ulAddress,
			ulInn: defaultProfile.ulInn,
			ulPinfl: defaultProfile.ulPinfl,
			customerType: profile.customerType
		};
	}

	openNotification() {
		this.$emit("openNotification");
	}

	get textHeader() {
		return this.isSm;
	}

}

